import { Divider, Flex, Switch, Text } from '@modusign/design-system';

import { ContextMenuRow, ContextMenuWrapper } from '@app/components/ContextMenu';
import ContextMenuRowParticipantName from '@app/components/ContextMenuRowParticipantName';

interface SignatureFieldContextMenuProps {
  displayName?: string;
  participantOrder: number;
  signerResizable: boolean;
  disabledSignatureGenerator?: boolean;
  onToggleSignerResizeOption: () => void;
  onToggleDisableSignatureGeneratorClicked?: () => void;
}

export function SignatureFieldContextMenu({
  displayName,
  participantOrder,
  signerResizable,
  disabledSignatureGenerator,
  onToggleSignerResizeOption,
  onToggleDisableSignatureGeneratorClicked,
}: SignatureFieldContextMenuProps) {
  return (
    <ContextMenuWrapper>
      <>
        {displayName && (
          <>
            <ContextMenuRowParticipantName
              participantName={displayName}
              participantOrder={participantOrder}
            />
            <Divider />
          </>
        )}

        <ContextMenuRow>
          <Flex alignItems="center" gap={2} justifyContent="space-between">
            <Text fontSize="xs" fontWeight="medium">
              서명자가 크기 조절
            </Text>
            <Switch checked={signerResizable} size="sm" onClick={onToggleSignerResizeOption} />
          </Flex>
        </ContextMenuRow>
        {typeof disabledSignatureGenerator === 'boolean' && (
          <>
            <Divider />
            <ContextMenuRow>
              <Flex alignItems="center" gap={2} justifyContent="space-between">
                <Text fontSize="xs" fontWeight="medium">
                  도장 이미지 업로드만 허용
                </Text>
                <Switch
                  checked={disabledSignatureGenerator}
                  size="sm"
                  onClick={onToggleDisableSignatureGeneratorClicked}
                />
              </Flex>
            </ContextMenuRow>
          </>
        )}
      </>
    </ContextMenuWrapper>
  );
}
